import { createRouteRef } from '@backstage/core-plugin-api';
import { BLACKDUCK_PLUGIN_ID } from '@mercedes-benz/blackduck-common';

export const rootRouteRef = createRouteRef({
  id: BLACKDUCK_PLUGIN_ID,
});
